module.exports = __webpack_public_path__ + "static/media/kitchen-7.75c733c0.jpg";